export function timeToMilliseconds(time) {
  // Split the time string into hours and minutes
  const [hours, minutes] = time.split(':').map(Number);

  // Convert hours and minutes to milliseconds
  const hoursInMilliseconds = hours * 60 * 60 * 1000;
  const minutesInMilliseconds = minutes * 60 * 1000;

  // Add them together to get the total milliseconds
  return hoursInMilliseconds + minutesInMilliseconds;
}
